<template>
  <div class="pwd">
    <el-card class="msg">
      <div class="title">{{ $t("perMsg.message") }}</div>

      <ul>
        <li v-for="(item, index) in list" :key="index">
          <div class="msgTitle">
            <div class="fl">
              <strong>{{ item.title }}</strong>
            </div>
            <div class="fr">{{ item.createTime }}</div>
          </div>
          <div class="msgMsg">{{ item.content }}</div>
        </li>
      </ul>
      <el-pagination
        :page-size="pageSize"
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total="totalRecords"
      >
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
import Store from "../store";
export default {
  data() {
    return {
      store: Store.state,
      pageNumber: 1,
      pageSize: 99999,
      totalRecords: 1000,
      list: [
        {
          content:
            "伤害非卓科技，上海非卓科技，上海非卓科技，上海非卓科技，上海非卓，上海非卓科技，上海非卓科技，上海非卓科技，上海非卓科技，上海非卓科技",
          createTime: "2022-04-16 20:10:10",
          id: 0,
          title: "双十一惊喜活动：全场九折起！",
        },
      ],
    };
  },
  mounted() {
    document.addEventListener("keydown", function(e) {
      if (e.key === "F12" || e.keyCode === 123) {
        e.preventDefault();
      }
    });
    document.addEventListener("contextmenu", function(e) {
      e.preventDefault();
    });


    Store.setPath("5");
    this.init();
  },
  methods: {
    async init() {
      let { data: res } = await this.$http.post("/c/message/query", {
        pageNo: this.pageNumber,
        pageSize: this.pageSize,
      });
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      this.totalRecords = res.data.totalRecords;
      this.list = res.data.records;
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.init();
    },
  },
};
</script>
<style lang="less" scoped>
.msg {
  // width: 60rem;
  //   height: 46.875rem;
  .title {
    color: rgb(67, 188, 183);
    line-height: 2.5rem;
    border-bottom: 0.25rem solid rgb(67, 188, 183);
  }
  ul {
    padding-top: 1.25rem;
    li {
      // width: 53.75rem;
      height: 10rem;
      border: 0.0313rem solid #eee;
      margin-bottom: 0.625rem;
      padding: 0.625rem 1.25rem;
      .msgTitle {
        height: 3.4375rem;
        line-height: 3.4375rem;
        .fr {
          color: #ccc;
          font-size: 0.9em;
        }
      }
      .msgMsg {
        line-height: 2.5rem;
      }
    }
  }
}
</style>
